import * as types from "../types/notViewedOrders"

const initialState = {
  notViewedOrders: {
    notConfirmed: 0,
    pending: 0,
    paid: 0,
    canceled: 0,
    delivered: 0
  }
}

const notViewedOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INC_NUMBER_OF_ORDERS: {
      let result =
        state.notViewedOrders[action.orderStatus] + action.number

      result = result > 0 ? result : 0

      const newState = {
        ...state,
        notViewedOrders: {
          ...state.notViewedOrders,
          [action.orderStatus]: result
        }
      }

      return newState
    }
    case types.FETCH_NOT_VIEWED_ORDERS: {
      return { ...action.data }
    }
    case types.RESET_NOT_VIEWED_ORDERS: {
      const newState = {
        ...state,
        notViewedOrders: {
          ...state.notViewedOrders,
          [action.orderStatus]: 0
        }
      }

      return newState
    }
    default:
      return state
  }
}

export default notViewedOrdersReducer